export default "__VITE_ASSET__fe535d11__"